"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FORM_CONTROL_TOOL_TIP_TEXT = void 0;
const react_1 = __importDefault(require("react"));
const material_1 = require("@mui/material");
const Info_1 = __importDefault(require("@mui/icons-material/Info"));
const CustomizedToolTip_1 = __importDefault(require("../CustomizedToolTip"));
exports.FORM_CONTROL_TOOL_TIP_TEXT = "Exclude CMS Enrollees w/ RAF Type Codes: E, ED, E1, E2";
const InputLabelTypography = (0, material_1.styled)(material_1.Typography)(({ theme }) => ({
    lineHeight: theme.spacing(0.3),
}));
const Info = (0, material_1.styled)(Info_1.default)(({ theme }) => ({
    lineHeight: theme.spacing(0.3),
    fontSize: "1.25em",
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    color: theme.palette.formControlInfoIcon?.color,
    verticalAlign: "super",
    marginLeft: theme.spacing(0.2),
}));
exports.default = ({ label, className, displayInfo, }) => (react_1.default.createElement(InputLabelTypography, { className: className, variant: "caption", color: "textSecondary" },
    label,
    displayInfo ? (react_1.default.createElement(CustomizedToolTip_1.default, { arrow: true, placement: "top", title: exports.FORM_CONTROL_TOOL_TIP_TEXT },
        react_1.default.createElement(Info, null))) : null));
